<template>
  <!-- The ⋯ at the end of a list row (spec §5.7, place 3): everything for that one thing, always visible, never on hover only.
       What cannot be undone comes last, apart and in plum; something you expect but cannot do now stays, off, with its reason. -->
  <Button type="button" rounded text severity="secondary" :aria-label="t('rowmenu_label', { name })" aria-haspopup="true" :aria-controls="id"
    v-tooltip.top="t('rowmenu_label', { name })" @click="menu?.toggle($event)">
    <template #icon><AppIcon icon="ellipsis" /></template>
  </Button>
  <Menu :id="id" ref="menu" :model="model" popup>
    <template #item="{ item, props: p }">
      <a v-bind="p.action" class="flex items-start gap-2 px-3 py-2" :class="item.danger ? 'menu-danger' : ''">
        <AppIcon v-if="item.icon" :icon="item.icon" class="mt-px" />
        <span class="flex flex-col">
          <span>{{ item.label }}</span>
          <span v-if="item.disabled && item.reason" class="text-xs text-surface-500 dark:text-surface-400">{{ item.reason }}</span>
        </span>
      </a>
    </template>
  </Menu>
</template>

<script lang="ts" setup>
import type Menu from 'primevue/menu';

export type RowMenuItem = { label: string; icon?: string; command: () => void; danger?: boolean; disabled?: boolean; reason?: string };

const { t } = useI18n();

const props = defineProps<{ items: RowMenuItem[]; name: string }>();

const id = useId();
const menu = ref<InstanceType<typeof Menu>>();
const model = computed(() => {
  const safe = props.items.filter((i) => !i.danger);
  const danger = props.items.filter((i) => i.danger);
  return [...safe, ...(safe.length && danger.length ? [{ separator: true }] : []), ...danger];
});
</script>
